import "./utils/touch-detect";
import "./utils/isOutOfViewport";
import "./services/cookieService.js";
import { tagDelayService } from "./services/tagDelayService";

tagDelayService.init();


import "./views/cdn-caching";
import "./views/main-menu";
import "./views/service-menu";
import "./views/alert-banner";
import "./views/solid-tabs-block-accordion";
import "./views/countdown";
import "./views/modal";
import "./views/simple-dropdown";
import "./views/accesso-cart";
import "./views/hero-frontpage";
import "./views/hero-with-subnav";
import "./views/urgency";
import "./views/multi-cta-button";
import "./views/footer";
import "./views/hex";
import "./views/newsletter-form-validation";
import "./views/takeover";
import "./views/takeover-exit-intent";
import "./views/admin";
import "./views/filters";
import "./views/tables";
import "./views/show-more-button";
import "./views/umbraco-forms";
import "./views/entry-restriction-dates-map";